export function activateAnalytics() {
  import(/* webpackChunkName: "analytics" */ 'libs/analytics').then((analytics) =>
    analytics.init()
  );
}
